import {Component} from 'react';
import h from 'react-hyperscript';
import content from 'Assets/data/globals.json';
import './Footer.scss';
import footerLogo from 'Assets/google-gray.svg';
import Image from 'Components/Image/Image';

class Footer extends Component {
  render() {
    const {logo, links, help, report} = content.footer;
    return (
      h('footer', {
        className: 'footer',
      }, [
        h('div', {
          className: 'footer__lower container',
        },
        [
          h('a', {
            'className': 'footer__logo',
            'href': logo.href,
            'target': '_blank',
            'data-g-label': logo.attributes.label,
            'data-g-action': logo.attributes.action,
            'data-g-event': logo.attributes.event,
          }, h(Image, {
            src: footerLogo,
            alt: 'Google Logo',
          }, null)),

          h('ul', {
            className: 'footer__nav flex--wrap-sm',
            key: 'footer__nav',
          }, [
            links.map(({href, attributes, label}, key) => (
              h('li', {
                key,
              }, h('a', {
                'className': 'footer__nav-item',
                'href': href,
                'target': '_blank',
                'data-g-label': attributes.label,
                'data-g-action': attributes.action,
                'data-g-event': attributes.event,
              }, label))
            )),
            h('li', null,
                h('a', {
                  className: 'footer__nav-item',
                  href: '#',
                  onClick: (e) => {
                    e.preventDefault();
                    window.userfeedback.api.startFeedback({
                      'productId': '5144958',
                      'locale': 'en',
                    });
                  },
                }, report.label)
            ),
          ]),

          h('div', {
            className: 'footer__nav-right',
          }, [
            h('a', {
              'className': 'has-icon icon--pre footer__nav-item',
              'href': help.href,
              'target': '_blank',
              'data-g-label': help.attributes.label,
              'data-g-action': help.attributes.action,
              'data-g-event': help.attributes.event,
            }, [
              h('span', {
                className: 'material-icons footer__nav-icon',
              }, help.icon),
              help.label,
            ]),
          ]),
        ]
        ),
      ])
    );
  }
};

export default Footer;
